import { useContext } from 'react';
import { ConsentContext } from './context';
import React from 'react';

export default function ErrorMessage() {
  const { errorMessage } = useContext(ConsentContext);
  return <>{errorMessage && <p className='cmx__request_consent-modal__p-error-message mb-1'>{errorMessage}</p>}</>;
}
